import moment from 'moment'

const getDateTimeString = (dateTimeISOString) => {
  return moment(dateTimeISOString).format('YYYY-MM-DD hh:mm A')
}

export default getDateTimeString
